import React, { Suspense, useCallback } from 'react';

import { isNudeDomain } from '../../utils/helpers';
import FullLoader from '../../components/Loaders/FullLoader';


const GuestHomePage = React.lazy(() =>
  import('../../pages/Home/GuestHomePage')
);
const GuestHomePageV2 = React.lazy(() =>
  import('../../pages/Home/v2/GuestHomePageV2')
);
const MembersHomePage = React.lazy(() => import('../../pages/Home/Home'));

export function getHomeVariant() {
  const key = 'homepage_variant';

  const existing = localStorage.getItem(key);
  if (existing) {
    return existing;
  }

  const variant = Math.random() < 0.5 ? 'A' : 'B';

  localStorage.setItem(key, variant);

  return variant;
}

function HomePage(props) {
  const { user, activeCampaign, history, location } = props;
  const guestHomePageVariant = getHomeVariant();

  const userWithNoActiveMembership = !user?.user?.activeSubscription;

  const hasHomepageV2Feature = user?.features?.includes('HOMEPAGE_V2');

  const homePageToRender = useCallback(() => {
    if (
      userWithNoActiveMembership &&
      !isNudeDomain &&
      (guestHomePageVariant === 'A' && hasHomepageV2Feature)
    ) {
      return (
        <GuestHomePageV2
          activeCampaign={activeCampaign}
          history={history}
          location={location}
          user={user}
        />
      );
    }
    if (userWithNoActiveMembership && !isNudeDomain) {
      return (
        <GuestHomePage
          activeCampaign={activeCampaign}
          history={history}
          location={location}
          user={user}
        />
      );
    }

    return (
      <MembersHomePage
        activeCampaign={activeCampaign}
        history={history}
        location={location}
        user={user}
      />
    );
  }, [activeCampaign, history, userWithNoActiveMembership, location, user, hasHomepageV2Feature, guestHomePageVariant]);

  return <Suspense fallback={<FullLoader />}>{homePageToRender()}</Suspense>;
}

export default HomePage;
